import {SchemaTag} from 'folder-items/FileConstants';
import * as net from 'util/Net';

export interface AntibodyDomainApiInput {
  label: string;
  aaSequenceId: string;
}

export interface CreateAntibodyApiInput {
  name: string;
  folderId: string;
  schemaId: string;
  domains: Array<AntibodyDomainApiInput>;
}

export function createAntibodies(params: Array<CreateAntibodyApiInput>): Promise<{
  antibodyIds: Array<string>;
}> {
  return net.postJSONPromise({
    url: '/1/api/antibodies',
    data: {params},
  });
}
export interface UpdateAntibodyInput {
  domains: Array<AntibodyDomainApiInput>;
}

interface UpdateAntibodyResponse {
  antibodyId: string;
  versionId: string;
  tags: Array<SchemaTag>;
}

export function editAntibodyStructure(
  antibodyId: string,
  expectedVersionId: string,
  params: UpdateAntibodyInput
): Promise<UpdateAntibodyResponse> {
  return net.postJSONPromise({
    url: `/1/api/antibodies/${antibodyId}-${expectedVersionId}/actions/update-structure`,
    data: params,
  });
}

export function resetAntibodyToVersion(
  antibodyId: string,
  versionId: string,
  expectedCurrentVersionId: string
): Promise<UpdateAntibodyResponse> {
  return net.postJSONPromise({
    url: `/1/api/antibodies/${antibodyId}/actions/reset-version`,
    data: {versionId, expectedCurrentVersionId},
  });
}
